export default {
  ENROLLMENT_WIDGET_TITLE: 'Flexible Rewards',
  ENROLLMENT_AVAILABILITY_SUBTITLE: 'Available until',
  AMOUNT_OF_DAYS_LEFT: '(%COUNT% days left)',
};
